import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { LocationModel } from '../../constants/dataTypes';
export interface PersonModel {
    id: null | string,
    name: null | string,
    company: {
        id: null | string,
        name: null | string,
        defaultLocation: LocationModel | null
    }
}

export interface PersonStoreState extends PersonModel {
    setState: (data: PersonModel) => void,
    setDefaultLocation: (location: LocationModel) => void,
    destroy: () => void
}

const initialState = {
    id: null,
    name: null,
    company: {
        id: null,
        name: null,
        defaultLocation: null
    }
}

const usePersonStore = create<PersonStoreState>()(
    /* @ts-ignore */
    persist(
        (set) => ({
            id: null,
            name: null,
            company: {
                id: null,
                name: null,
                defaultLocation: null
            },
            setState: (data) => {
                set(() => data)
            },
            setDefaultLocation: (location: LocationModel) => {
                set((state) => ({
                    ...state,
                    company: {
                        ...state.company,

                        defaultLocation: location
                    },
                }))
            },
            destroy: () => set(() => initialState)
        }),
        {
            name: 'active-person',
            storage: {
                getItem: (name) => {
                    const storedValue = sessionStorage.getItem(name);
                    return storedValue ? JSON.parse(storedValue) : null;
                },
                setItem: (name, value) => {
                    sessionStorage.setItem(name, JSON.stringify(value));
                },
                removeItem: (name) => {
                    sessionStorage.removeItem(name);
                },
            },
        }
    ),
);

export default usePersonStore;